import React, { useEffect, useMemo, useState, useContext } from 'react'
import LabelTopView from '../Utility/LabelTopView';
import { ChartBarBigIcon } from 'lucide-react';
import HeaderWithButton from '../Utility/HeaderWithButton';
import TableHeader from '../Utility/TableHeader';
import { use } from 'react';
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Pagination } from '../../helper/HelperTwo';
import Select from "react-select";
import { useExcelDownload, usePDFDownload } from "../../helper/HelperTwo";
import { DataContext } from "../../helper/HelperOne";


const SalesList = () => {
    const tabName = localStorage.getItem("tab_name");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [sales, setSales] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState(null);
    const [filter, setFilter] = useState({
        sales_order_no: "",
        party_name: "",
        type_of_work: "",
        sales_or_service: tabName || "",
        sales_person: "",
        project_manager: "",
        labour_name: "",
        invoice_date_filter: "",
        invoice_date_from: "",
        invoice_date_to: "",
        create_date_filter: "",
        create_date_from: "",
        create_date_to: "",
    });
    const [salesmanData, setSalesmanData] = useState([]);
    const [workersData, setWorkersData] = useState([]);
    const [typeOfWork, setTypeOfWork] = useState([]);
    const [projectManagerList, setProjectManagerList] = useState([]);
    const [colors, setColors] = useState([]);
    const { searchData } = useContext(DataContext);

    const [salesOrderStatus, setSalesOrderStatus] = useState([]);
    const [salesOrderNumber, setSalesOrderNumber] = useState([]);
    const [salesOrderPartyName, setSalesOrderPartyName] = useState([]);
    const [filtersReset, setFiltersReset] = useState(false);

    const { PDFDownload } = usePDFDownload();
    const { excelDownload } = useExcelDownload();

    const fetchSale = async (page = 1) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            let url = `public/api/sales?page=${page}&sales_or_service=${tabName}`
            if (searchData) {
                url += `&search=${searchData}`
            }
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            })

            const [salesmanResponse, workersResponse, typeOfWorkResponse, projectManagerResponse, saleOrderNumberResponse, saleOrderPartyResponse] = await Promise.all([
                axios.get('public/api/salesmen/list', {
                    headers: { Authorization: `Bearer ${token}` },
                }),
                axios.get('public/api/workers/list', {
                    headers: { Authorization: `Bearer ${token}` },
                }),
                axios.get('public/api/type-of-works/list', {
                    headers: { Authorization: `Bearer ${token}` },
                }),
                axios.get('public/api/project-manager/list', {
                    headers: { Authorization: `Bearer ${token}` },
                }),
                axios.get('public/api/sales-orders-status/list', {
                    headers: { Authorization: `Bearer ${token}` },
                }),

                axios.get('public/api/sales-orders/party-name-list', {
                    headers: { Authorization: `Bearer ${token}` },
                }),
            ])


            setSalesmanData(salesmanResponse?.data);
            setWorkersData(workersResponse?.data);
            setTypeOfWork(typeOfWorkResponse?.data);
            setProjectManagerList(projectManagerResponse?.data);


            if (response?.data) {

                const salesData = response?.data?.sales?.data || [];

                const uniqueWorks = [
                    ...new Set(salesData.map((q) => q.type_of_work).filter(Boolean)),
                ];
                const colorList = generateColors(uniqueWorks.length);
                setColors(colorList);
                setSales(response?.data?.sales?.data);
                setCurrentPage(response?.data?.sales?.current_page);
                setPagination(response?.data?.sales);
            }




        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm/");
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchSale();
    }, [searchData]);


    const handleDownloadPDF = () => {
        const params = {
            sales_order_no: filter?.sales_order_no || "",
            party_name: filter?.party_name || "",
            type_of_work: filter?.type_of_work || "",
            sales_or_service: filter?.sales_or_service || "",
            sales_person: filter?.sales_person || "",
            project_manager: filter?.project_manager || "",
            labour_name: filter?.labour_name || "",
            quotation_no: filter?.quotation_no || "",
            invoice_date_filter: filter?.invoice_date_filter || "",
            invoice_date_from: filter?.invoice_date_from || "",
            invoice_date_to: filter?.invoice_date_to || "",
            create_date_filter: filter?.create_date_filter || "",
            create_date_from: filter?.create_date_from || "",
            create_date_to: filter?.create_date_to || "",
        };

        PDFDownload("sales", "sales.pdf", params, setLoading);
    }




    const handleDownloadExcel = () => {
        const params = {
            sales_order_no: filter?.sales_order_no || "",
            party_name: filter?.party_name || "",
            type_of_work: filter?.type_of_work || "",
            sales_or_service: filter?.sales_or_service || "",
            sales_person: filter?.sales_person || "",
            project_manager: filter?.project_manager || "",
            labour_name: filter?.labour_name || "",
            quotation_no: filter?.quotation_no || "",
            invoice_date_filter: filter?.invoice_date_filter || "",
            invoice_date_from: filter?.invoice_date_from || "",
            invoice_date_to: filter?.invoice_date_to || "",
            create_date_filter: filter?.create_date_filter || "",
            create_date_from: filter?.create_date_from || "",
            create_date_to: filter?.create_date_to || "",
        };

        excelDownload("sales", "sales.xlsx", params, setLoading);
    };
    const handleFilter = async (page = 1) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const queryParams = new URLSearchParams({
                page: page,
                sales_order_no: filter?.sales_order_no || "",
                party_name: filter?.party_name || "",
                type_of_work: filter?.type_of_work || "",
                sales_or_service: filter?.sales_or_service || "",
                sales_person: filter?.sales_person || "",
                project_manager: filter?.project_manager || "",
                labour_name: filter?.labour_name || "",
                quotation_no: filter?.quotation_no || "",
                invoice_date_filter: filter?.invoice_date_filter || "",
                invoice_date_from: filter?.invoice_date_from || "",
                invoice_date_to: filter?.invoice_date_to || "",
                create_date_filter: filter?.create_date_filter || "",
                create_date_from: filter?.create_date_from || "",
                create_date_to: filter?.create_date_to || "",
                search: searchData,
            }).toString();
            const response = await axios.get(`public/api/sales?${queryParams}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json"
                },
            });


            setSales(response?.data?.sales?.data);
            setCurrentPage(response?.data?.sales?.current_page);
            setPagination(response?.data?.sales);
            const salesData = response?.data?.sales?.data || [];

            const uniqueWorks = [
                ...new Set(salesData.map((q) => q.type_of_work).filter(Boolean)),
            ];
            const colorList = generateColors(uniqueWorks.length);
            setColors(colorList);


        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm/");
            }
            setError("Network Failed. Please try again.");
        } finally {
            setLoading(false);

        }
    }

    const resetFilters = async () => {
        setLoading(true);
        setFilter({
            sales_order_no: "",
            party_name: "",
            type_of_work: "",
            sales_or_service: tabName || "",
            sales_person: "",
            project_manager: "",
            labour_name: "",

            invoice_date_filter: "",
            invoice_date_from: "",
            invoice_date_to: "",
            create_date_filter: "",
            create_date_from: "",
            create_date_to: "",
        });
        setLoading(false);
        setFiltersReset(true);
    };

    useEffect(() => {
        if (filtersReset) {
            fetchSale(1);
            setFiltersReset(false);
        }
    }, [filtersReset]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value,
        });
    };

    const salesServiceOptions = [
        {
            value: "sales",
            name: "Sales",
        },
        {
            value: "service",
            name: "Service",
        },
    ];


    const randomColorMap = useMemo(() => {
        const map = {};
        if (!sales || sales.length === 0 || !colors?.length) return map;

        const uniqueWorks = [
            ...new Set(sales.map((lead) => lead?.type_of_work).filter(Boolean)),
        ];

        uniqueWorks.forEach((work, index) => {
            map[work] = colors[index % colors.length]; // assign color deterministically
        });

        return map;
    }, [sales, colors]);

    const generateColors = (count) => {
        const colors = [];

        for (let i = 0; i < count; i++) {
            const hue = Math.floor(Math.random() * 360); // full color range
            const saturation = Math.floor(Math.random() * 40) + 70; // 70–100% = very colorful
            const lightness = Math.floor(Math.random() * 30) + 20; // 60–90% = bright

            const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
            colors.push(color);
        }

        return colors;
    };


    const headers = [
        "S No",
        "Sales Order No",
        "Delivery Note No",
        "Sales Invoice No",
        "Sales Invoice Date",
        "Party Name",
        "Mobile No",
        "Type Of Work",
        "Sales/Service",
        "Sales Person",
        "Project Manager",
        "Labour Name",
        "Sale Ledger",
        "Sync Status",
        "Sales Created Date",
        "Sales Invoices Amount",
        "OverDue Days",
    ];

    const handlePageChange = (page) => {

        if (page !== "...") {
            handleFilter(page);
        }
    };

    if (loading) {
        return (
            <div className="h-screen bg-white">
                <div className="flex justify-center items-center h-full">
                    <img
                        className="h-16 w-16"
                        src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
                        alt="loader"
                    />
                </div>
            </div>
        );
    }

    if (error) {
        <div className="h-screen bg-white flex flex-col justify-center items-center">
            <p className="mb-4 text-red-600 font-medium">Something went wrong.</p>
            <button
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={() => {
                    setError(null); // hide error while retrying
                    fetchSale(); // retry API
                }}
            >
                Reload
            </button>
        </div>;
    }

    return (
        <div>
            <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-4">
                <div className="flex-1">
                    <LabelTopView label="Sales Overview" icon={<ChartBarBigIcon />} />
                </div>
            </div>


            <HeaderWithButton
                title="Sales List"
                description="Sales "
                buttonText="Sales"
                // onButtonClick={handleAddLead}
                showButton={false}
            />

            <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 items-end mt-4">
                {/* Date filter */}


                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Sales Person
                    </label>
                    <Select
                        name="sales_person"
                        options={salesmanData?.map((cust) => ({
                            value: cust.name,
                            label: cust.name,
                        }))}
                        value={
                            salesmanData
                                ?.map((cust) => ({
                                    value: cust.name,
                                    label: cust.name,
                                }))
                                .find((cust) => cust.value === filter.sales_person) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "sales_person",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Sales Person"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>

                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Project Manager
                    </label>
                    <Select
                        name="project_manager"
                        options={projectManagerList?.map((cust) => ({
                            value: cust?.name,
                            label: cust?.name,
                        }))}
                        value={
                            projectManagerList?.map((cust) => ({
                                value: cust?.name,
                                label: cust?.name,
                            }))
                                .find((cust) => cust.value === filter?.project_manager) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "project_manager",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Project Manager"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>

                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Labour
                    </label>
                    <Select
                        name="worker_tally_id"
                        options={workersData?.map((cust) => ({
                            value: cust.name,
                            label: cust.name,
                        }))}
                        value={
                            workersData
                                ?.map((cust) => ({
                                    value: cust.name,
                                    label: cust.name,
                                }))
                                .find((cust) => cust.value === filter.labour_name) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "labour_name",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Labour"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>

                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Type of Work
                    </label>
                    <Select
                        name="type_of_work"
                        options={typeOfWork?.map((work) => ({
                            value: work.name,
                            label: work.name,
                        }))}
                        value={
                            // Find the option where option.value matches filter.type_of_work
                            typeOfWork
                                ?.map((work) => ({ value: work.name, label: work.name }))
                                .find((option) => option.value === filter.type_of_work) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "type_of_work",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Type of Work"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>

                <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Sales / Service
                    </label>
                    <Select
                        name="sales_or_service"
                        options={salesServiceOptions?.map((item) => ({
                            value: item.value,
                            label: item.name,
                        }))}
                        value={
                            salesServiceOptions
                                ?.map((item) => ({
                                    value: item.value,
                                    label: item.name,
                                }))
                                .find((option) => option.value === filter.sales_or_service) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "sales_or_service",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Sales / Service"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div>





                {/* <div className="w-full">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Party Name
                    </label>
                    <Select
                        name="party_name"
                        options={salesOrderPartyName?.map((item) => ({
                            value: item.party_name,
                            label: item.party_name,
                        }))}
                        value={
                            salesOrderPartyName
                                ?.map((item) => ({
                                    value: item.party_name,
                                    label: item.party_name,
                                }))
                                .find((option) => option.value === filter.party_name) || null
                        }
                        onChange={(selectedOption) =>
                            handleChange({
                                target: {
                                    name: "party_name",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        isMulti={false}
                        isClearable={true}
                        placeholder="Select Status"
                        className="react-select-container"
                        classNamePrefix="select"
                    />
                </div> */}



                {/* <div className="space-y-3 ">
                 
                    <div className="">
                        <label className="block text-sm font-medium text-gray-700">
                            Status
                        </label>
                        <select
                            name="status"
                            value={filter?.status}
                            onChange={handleChange}
                            className="border border-gray-300 p-2 rounded w-full mt-2"
                        >
                            <option value="" className="text-gray-300">
                                -- Select --
                            </option>
                            <option value="1. Win">1. Win</option>
                            <option value="2. Follow-up">2. Follow-up</option>
                            <option value="3. Lost">3. Lost</option>
                            <option value="4. Negotiation">4.Negotiation</option>
                        </select>
                    </div>
                </div> */}

                {/* <div className="space-y-3 ">
                    
                    <div className="">
                        <label className="block text-sm font-medium text-gray-700">
                            Quote Sent Status
                        </label>
                        <select
                            name="quote_sent_status"
                            value={filter?.quote_sent_status}
                            onChange={handleChange}
                            className="border border-gray-300 p-2 rounded w-full mt-2"
                        >
                            <option value="" className="text-gray-300">
                                -- Select --
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                </div> */}

                <div className="space-y-3 ">

                    <div className="">
                        <label className="block text-sm font-medium text-gray-700">
                            Sales  Create Date
                        </label>
                        <select
                            name="create_date_filter"
                            value={filter?.create_date_filter}
                            onChange={handleChange}
                            className="border border-gray-300 p-2 rounded w-full mt-2"
                        >
                            <option value="" className="text-gray-300">
                                -- Select --
                            </option>
                            <option value="today">Today</option>
                            <option value="yesterday">Yesterday</option>
                            <option value="this_week">This Week</option>
                            <option value="this_month">This Month</option>
                            <option value="this_year">This Year</option>
                            <option value="custom">Custom Range</option>
                        </select>
                    </div>
                </div>

                {filter.create_date_filter === "custom" && (
                    <>
                        <div className="space-y-3 ">
                            <div className="">
                                <label className="block text-sm font-medium">Date From</label>
                                <input
                                    type="date"
                                    name="create_date_from"
                                    value={filter?.create_date_from}
                                    onChange={handleChange}
                                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                                />
                            </div>
                        </div>
                        <div className="space-y-3 ">
                            <div className="w-full">
                                <label className="block text-sm font-medium">Date To</label>
                                <input
                                    type="date"
                                    name="create_date_to"
                                    value={filter?.create_date_to}
                                    onChange={handleChange}
                                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                                />
                            </div>
                        </div>
                    </>
                )}

                <div className="space-y-3 ">

                    <div className="">
                        <label className="block text-sm font-medium text-gray-700">
                            Invoices Date
                        </label>
                        <select
                            name="invoice_date_filter"
                            value={filter.invoice_date_filter}
                            onChange={handleChange}
                            className="border border-gray-300 p-2 rounded w-full mt-2"
                        >
                            <option value="" className="text-gray-300">
                                -- Select --
                            </option>
                            <option value="today">Today</option>
                            <option value="yesterday">Yesterday</option>
                            <option value="this_week">This Week</option>
                            <option value="this_month">This Month</option>
                            <option value="this_year">This Year</option>
                            <option value="custom">Custom Range</option>
                        </select>
                    </div>
                </div>

                {filter.invoice_date_filter === "custom" && (
                    <>
                        <div className="space-y-3 ">
                            <div className="">
                                <label className="block text-sm font-medium">Date From</label>
                                <input
                                    type="date"
                                    name="invoice_date_from"
                                    value={filter?.invoice_date_from}
                                    onChange={handleChange}
                                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                                />
                            </div>
                        </div>
                        <div className="space-y-3 ">
                            <div className="w-full">
                                <label className="block text-sm font-medium">Date To</label>
                                <input
                                    type="date"
                                    name="invoice_date_to"
                                    value={filter?.invoice_date_to}
                                    onChange={handleChange}
                                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className="flex flex-wrap gap-4 mt-4">
                {/* Submit Button */}
                <button
                    // ref={submitBtnRef}
                    onClick={() => handleFilter(1)}
                    className="bg-blue-600 text-white font-semibold py-2 px-6 rounded-md hover:bg-blue-700 transition"
                >
                    Submit
                </button>

                {/* Reset Button */}
                <button
                    onClick={resetFilters}
                    className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
                >
                    Reset
                </button>
                <button
                    onClick={handleDownloadPDF}
                    className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
                >
                    PDF
                </button>
                <button
                    onClick={handleDownloadExcel}
                    className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
                >
                    Excel
                </button>
            </div>

            <div className="overflow-x-auto mt-8">
                <table className="min-w-full border border-gray-300 border-collapse">
                    <TableHeader headers={headers} />
                    <tbody>
                        {sales?.length > 0 ? (
                            sales?.map((item, index) => (
                                <tr
                                    key={index}
                                    className="hover:bg-gray-50 transition duration-300 ease-in-out"
                                >
                                    <td className="border border-gray-300 whitespace-nowrap text-md sm:pl-4 text-center">
                                        {pagination.from + index}
                                    </td>

                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.sales_order_no || "N/A"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.delivery_note_no || "N/A"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.sales_invoice_no || "N/A"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {new Date(item?.sales_invoice_date).toLocaleDateString("en-GB") || item?.sales_invoice_date || "N/A"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.party_name || "N/A"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-blue-500 sm:pl-4 text-center p-5"
                                    >


                                        {/* <a href={`tel:${item?.mobile_no}`}>
                                            {" "}
                                            {item?.mobile_no || "N/A"}{" "}
                                        </a> */}


                                        {item?.mobile_no ? (
                                            <a href={`tel:${item.mobile_no}`}>
                                                {item.mobile_no}
                                            </a>
                                        ) : (
                                            <span className="text-gray-400">N/A</span>
                                        )}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        <span
                                            className="text-xs rounded px-1"
                                            style={{
                                                color: randomColorMap[item.type_of_work],
                                                border: `1px solid ${randomColorMap[item.type_of_work]
                                                    }`,
                                            }}
                                        >
                                            {item.type_of_work || "N/A"}
                                        </span>
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.sales_or_service || "N/A"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.sales_person || "N/A"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.project_manager || "N/A"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.labour_name || "N/A"}
                                    </td>

                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.sales_ledger || "N/A"}
                                    </td>

                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.sync_status || "N/A"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.sales_create_date ? new Date(item?.sales_create_date).toLocaleDateString("en-GB") : "N/A"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.sales_invoice_amount || "0.00"}
                                    </td>
                                    <td
                                        className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5"
                                    >
                                        {item?.over_due_by_days || "N/A"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={headers.length} className="text-center py-4">
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>

            {pagination && (
                <Pagination
                    links={pagination.links}
                    currentPage={pagination.current_page}
                    totalResults={pagination.total}
                    from={pagination.from}
                    to={pagination.to}
                    lastPage={pagination.last_page}
                    onPageChange={handlePageChange}
                />
            )}
        </div>
    )
}

export default SalesList